import React from 'react';
import { Link } from 'react-router-dom';
import { Warning } from '@phosphor-icons/react';
import { useAuth } from '@/App';

/**
 * Bandeau persistant affichant un rappel de consentement pour les clients qui
 * n'ont pas encore accepté la politique de confidentialité + les CGV.
 * Bloquant pour la création de commande (contrôlé côté backend).
 */
export default function ConsentBanner() {
  const { user, needsConsent } = useAuth();
  if (!needsConsent || !user) return null;

  const missing = [];
  if (!user.privacy_accepted) missing.push('la politique de confidentialité');
  if (!user.cgv_accepted) missing.push('les CGV');

  return (
    <div className="bg-amber-50 border-b border-amber-300 text-amber-900" data-testid="consent-banner">
      <div className="max-w-7xl mx-auto px-4 py-2.5 flex items-center gap-3 text-sm">
        <Warning size={18} weight="fill" className="text-amber-700 flex-shrink-0" />
        <p className="flex-1">
          <strong>Consentement requis :</strong> Vous devez accepter {missing.join(' et ')} avant de pouvoir passer une nouvelle commande.
        </p>
        <Link
          to="/consent"
          className="inline-flex items-center px-3 py-1.5 rounded-sm bg-amber-900 hover:bg-amber-950 text-white text-xs font-medium transition-colors whitespace-nowrap"
          data-testid="consent-banner-cta"
        >
          Accepter maintenant
        </Link>
      </div>
    </div>
  );
}
